import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=4953ab4c&scoped=true&"
import script from "./FaqList.vue?vue&type=script&lang=js&"
export * from "./FaqList.vue?vue&type=script&lang=js&"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=4953ab4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953ab4c",
  null
  
)

export default component.exports